import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(private authService: MsalService) {}

  logout() {
    this.authService.logoutRedirect().pipe(take(1)).subscribe();
  }
}
